export { default } from './add-equipment-heading';
